import { SvgIcon, SvgIconProps } from "@mui/material";

export const GoBasicPlanIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M34.3602 28.7501L33.719 31.5313C33.6553 31.8069 33.5002 32.0527 33.2788 32.2286C33.0575 32.4046 32.783 32.5003 32.5002 32.5001H7.50021C7.21744 32.5003 6.94296 32.4046 6.7216 32.2286C6.50024 32.0527 6.34508 31.8069 6.28146 31.5313L5.64021 28.7501H34.3602ZM37.469 15.2813L34.9377 26.2501H5.06271L2.53146 15.2813C2.47734 15.0446 2.4933 14.7972 2.57738 14.5693C2.66146 14.3415 2.81004 14.143 3.00499 13.9982C3.19993 13.8533 3.43282 13.7683 3.67524 13.7536C3.91766 13.7388 4.15914 13.7949 4.37021 13.9151L12.1065 18.3363L18.959 8.05758C19.1827 7.72258 19.5527 7.51508 19.954 7.50008C20.1521 7.49188 20.3494 7.53143 20.5291 7.6154C20.7087 7.69937 20.8656 7.8253 20.9865 7.98258L29.0227 18.3151L35.5565 13.9601C35.765 13.8222 36.01 13.7498 36.2601 13.7523C36.5101 13.7549 36.7536 13.8322 36.9593 13.9743C37.165 14.1164 37.3235 14.3168 37.4143 14.5498C37.5051 14.7827 37.5242 15.0375 37.469 15.2813Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const GoPlusPlanIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M8.29806 14.5844L11.3354 16.5029C11.3804 16.5313 11.4305 16.5505 11.483 16.5593C11.5354 16.5681 11.5891 16.5663 11.6408 16.5541C11.6926 16.5419 11.7414 16.5195 11.7844 16.4882C11.8274 16.4569 11.8637 16.4173 11.8912 16.3718L13.7296 13.3345C13.7759 13.258 13.7953 13.1681 13.7845 13.0793C13.7737 12.9905 13.7335 12.9078 13.6702 12.8446L10.553 9.72707C10.5065 9.68056 10.4493 9.64623 10.3864 9.62712C10.3235 9.60801 10.2568 9.60471 10.1923 9.61751C10.1278 9.63031 10.0675 9.65882 10.0166 9.70051C9.96577 9.74219 9.92598 9.79578 9.90078 9.85651L8.14222 14.0927C8.106 14.1799 8.10179 14.2771 8.1303 14.3671C8.15882 14.457 8.21824 14.534 8.29806 14.5844ZM25.9542 13.3346L27.7926 16.3719C27.8282 16.4308 27.8784 16.4794 27.9384 16.5132C27.9983 16.547 28.066 16.5648 28.1348 16.5647C28.2098 16.5647 28.2839 16.5436 28.3484 16.503L31.3857 14.5845C31.4655 14.5341 31.5249 14.4571 31.5535 14.3672C31.582 14.2772 31.5778 14.1801 31.5416 14.0929L29.783 9.85667C29.7578 9.79594 29.718 9.74235 29.6672 9.70067C29.6163 9.65898 29.556 9.63047 29.4915 9.61767C29.427 9.60487 29.3603 9.60817 29.2974 9.62728C29.2345 9.64639 29.1773 9.68072 29.1308 9.72723L26.0136 12.8447C25.9503 12.908 25.9101 12.9906 25.8993 13.0794C25.8886 13.1682 25.9079 13.2581 25.9542 13.3346ZM7.66846 29.0795H31.9885V31.7995H7.66846V29.0795Z"
        fill="#008B07"
      />
      <path
        d="M36.8705 12.6795H36.8569C36.6837 12.6795 36.5238 12.7312 36.394 12.827L27.8168 18.9902L20.4307 9.30599C20.2794 9.10751 20.0441 8.99951 19.7944 8.99951C19.5445 8.99951 19.3082 9.10615 19.1571 9.30519L11.8111 18.979L3.26781 12.8185C3.12865 12.7173 2.96053 12.6639 2.78852 12.6661C2.6165 12.6683 2.4498 12.726 2.31325 12.8306C2.1768 12.9352 2.07768 13.0809 2.03059 13.2463C1.9835 13.4116 1.99094 13.5877 2.05181 13.7485L7.13037 27.183C7.24813 27.4941 7.54597 27.7196 7.87853 27.7196H31.7899C32.1225 27.7196 32.4204 27.4938 32.5381 27.1828L37.6081 13.779C37.6482 13.6831 37.6688 13.5802 37.6687 13.4763C37.6686 13.035 37.3117 12.6795 36.8705 12.6795ZM19.8685 24.0978L17.2933 20.3995L19.8685 16.7012L22.4435 20.3995L19.8685 24.0978Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const GoPremiumPlanIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M8.738 10.0869C8.738 10.2805 9.02059 10.4972 9.39828 10.4972H30.5352C30.9127 10.4972 31.1953 10.2805 31.1953 10.0869V6.03185L26.6279 9.36419C25.8016 9.94608 24.6856 9.89179 23.9199 9.23241L19.9666 5.62673L16.011 9.2343C15.2452 9.89432 14.1289 9.94888 13.3028 9.36638L8.738 6.03185V10.0869ZM13.9849 18.8475L18.372 14.4603H8.79996L13.9849 18.8475ZM19.9646 14.7362L15.6165 19.0839H24.2691L19.9646 14.7362ZM27.6556 19.0839H38.3697C38.3203 18.9976 38.2527 18.923 38.1715 18.8656L32.6307 14.8741L27.6556 19.0839ZM31.0744 14.4603H21.5499L25.892 18.8456L31.0744 14.4603ZM21.0226 38.7501L37.807 20.4049H26.3483L21.0226 38.7501ZM14.902 20.4049L19.9375 37.7501L24.9725 20.4049H14.902ZM2.12618 20.4049L18.8246 38.6563L13.5262 20.4049H2.12618ZM7.27035 14.8964L1.76085 18.8655C1.67966 18.9231 1.61198 18.9976 1.5625 19.0839H12.2188L7.27035 14.8964ZM10.059 3.23173C10.059 4.326 9.17175 5.21311 8.0773 5.21311C6.98284 5.21311 6.09591 4.32603 6.09591 3.23173C6.09591 2.13742 6.98284 1.25 8.0773 1.25C9.17175 1.25 10.059 2.13742 10.059 3.23173ZM21.9481 3.23173C21.9481 4.326 21.0609 5.21311 19.9666 5.21311C18.872 5.21311 17.9852 4.32603 17.9852 3.23173C17.9852 2.13742 18.872 1.25 19.9666 1.25C21.0609 1.25 21.9481 2.13742 21.9481 3.23173ZM33.8373 3.23173C33.8373 4.326 32.9502 5.21311 31.856 5.21311C30.7616 5.21311 29.8743 4.32603 29.8743 3.23173C29.8743 2.13742 30.7616 1.25 31.856 1.25C32.9501 1.25 33.8373 2.13742 33.8373 3.23173Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const UpgradePlanButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M5.8335 14.1668L14.1668 5.8335M14.1668 5.8335H5.8335M14.1668 5.8335V14.1668"
        stroke="url(#paint0_linear_32099_48594)"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_32099_48594"
          x1="5.8335"
          y1="10.0002"
          x2="14.1668"
          y2="10.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C4DED" />
          <stop offset="1" stopColor="#9D00EC" />
        </linearGradient>
      </defs>{" "}
    </SvgIcon>
  );
};

export const GinoAddOnsButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M5.8335 14.1668L14.1668 5.8335M14.1668 5.8335H5.8335M14.1668 5.8335V14.1668"
        stroke="#008B07"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SuccessStatusIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      style={{ width: "8", height: "7", fill: "none" }}
    >
      <path d="M1 2.71429L3.18182 5L7 1" stroke="#008B07" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const FailedStatusIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      style={{ width: "8", height: "8", fill: "none" }}
    >
      <path d="M7 1L1 7M7 7L1 1" stroke="#B42318" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const ViewIconButton = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      style={{ width: "19", height: "14", fill: "none" }}
    >
      <path
        d="M1.05339 7.26115C0.939901 7.08145 0.883156 6.9916 0.851391 6.85301C0.827531 6.74891 0.827531 6.58475 0.851391 6.48065C0.883156 6.34206 0.939901 6.25221 1.05339 6.07251C1.99123 4.58753 4.78279 0.833496 9.03696 0.833496C13.2911 0.833496 16.0827 4.58753 17.0205 6.07251C17.134 6.25221 17.1908 6.34206 17.2225 6.48065C17.2464 6.58475 17.2464 6.74891 17.2225 6.85301C17.1908 6.9916 17.134 7.08145 17.0205 7.26114C16.0827 8.74613 13.2911 12.5002 9.03696 12.5002C4.78279 12.5002 1.99123 8.74613 1.05339 7.26115Z"
        stroke="#98A2B3"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.03696 9.16683C10.4177 9.16683 11.537 8.04754 11.537 6.66683C11.537 5.28612 10.4177 4.16683 9.03696 4.16683C7.65625 4.16683 6.53696 5.28612 6.53696 6.66683C6.53696 8.04754 7.65625 9.16683 9.03696 9.16683Z"
        stroke="#98A2B3"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export const PendingStatusIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      style={{ width: "8", height: "8", fill: "none" }}
    >
      <circle cx="4" cy="4" r="3" fill="#1570EF" />
    </SvgIcon>
  );
};

export const FeaturesAccordionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      style={{ width: "14", height: "8", fill: "none" }}
    >
      <path d="M1 1L7 7L13 1" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const FeatureItemIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      style={{ width: "10", height: "10", fill: "none" }}
    >
      <circle cx="5" cy="5" r="5" fill="#17B26A" />
    </SvgIcon>
  );
};
